import type { NotificationFilter } from '@fv/models'

export const pinnedFilter: NotificationFilter = { pinned: true }

export const onlyUnread = (filter: NotificationFilter): NotificationFilter => {
  return {
    ...filter,
    onlyUnread: true,
  }
}
